import styled, { createGlobalStyle, css } from "styled-components";
import { Colors, FInter, FlexBox, ExternalLink } from "@brg/ui";
import changebg from "./changebg.svg";
import { bColor } from "../../../core/utils/bColor";
import { LabelRedStar } from "../../../shared/pages/designerEditView/styles";
import { IconWrapperAdd } from "../../../shared/assets/styles";
import { BTagsGrid } from "../../../core/components";
import { LayoutConst } from "core/modules";
import { ShowMoreContent } from "shared/pages/designer/styles";
import { ProjectEditPageGridList } from "_deziiign/books/pages/BookEdit/styles";
import { DefaultButton } from "shared/pages/teams/styles";

export const ProjectEditPageContainer = styled(FlexBox)`
  flex-direction: column;
  width: 100%;
  padding-top: 40px;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  .brg-input__value-container {
    height: 34px;
  }

  .tagss {
    .brg-input__control {
      width: 432px;
      overflow-x: scroll;
      overflow-y: hidden;
      padding-top: 3px;

      &::-webkit-scrollbar {
        display: none;
      }
    }

    .brg-input__value-container {
      width: auto !important;
      min-width: 10000px;
      max-width: 10000px;
      height: 40px;
      overflow: hidden;
    }
  }

  .brg-input__control {
    .gixVUY {
      top: -1px;
    }
  }

  .brg-input__option {
    position: relative;
  }

  .brg-input__menu-list {
    //min-height: 280px;
  }

  .brg-input__menu {
    z-index: 2000;
  }

  //@fixme: Z-position error
  .brg-input__menu {
    z-index: 100 !important;
  }

  .head__grey {
    margin-top: 0;
    padding-top: 0;
  }

  .brg-input__value-container {
    overflow: hidden;
    max-height: 40px;
  }

  @media (max-width: 940px) {
    margin-top: 24px;
  }
`;

export const ProjectEditPageGrid = styled(FlexBox)`
  flex-direction: column;
  width: 100%;
`;

export const ProjectEditPageGridRow = styled(FlexBox)`
  &:not(:first-child) {
    margin-top: 32px;
  }
`;

export const ProjectEditPageGridAuthorRow = styled(FlexBox)`
  &:not(:first-child) {
    margin-top: 8px;
  }
`;

export const ProjectEditPageGridLabel = styled(FInter.SmallTextFlex)`
  font-size: 18px;
  line-height: 32px;
  color: ${({ theme }) => theme.projectEdit.label};
  width: 127px;
  min-width: 127px;
  align-items: center;
  margin-right: 24px;
`;

// выбор бг на дезигне

interface IBgLayout {
  color: string;
  brighter?: string;
  darker?: string;
}

interface IFsProp {
  isMobile?: boolean;
  fontSize?: string;
  color?: string;
  pt?: string;
  fw?: string;
  lh?: string;
  ls?: string;
  halfBlock?: string;
  isShowcase?: boolean;
}

export const GlobalColoring = createGlobalStyle<IBgLayout>`
  ${(props) =>
    props.color && props.color !== ""
      ? css`
          .custom_title {
            color: ${bColor.isDark(props.color)
              ? Colors.geoWhite100
              : Colors.galBlack100};
          }
          ${LabelRedStar} {
            color: ${bColor.isDark(props.color) ? "#ff0000" : Colors.redFailed};
          }
          // .brg-input__option--is-focused {
          //     background: ${props.darker} !important;
          // }
          // .brg-input__control--is-focused {
          // }
          // .brg-input__menu,
          // .select__control,
          // .brg-input__control {
          //     background-color: ${props.brighter} !important;
          //     background: ${props.brighter} !important;
          //     border-color: ${props.darker} !important;
          //     border: 1px solid ${props.darker} !important;
          // }
        `
      : null};
`;

export const BgLayout = styled.div<IBgLayout>`
  background-color: ${(props) =>
    props.color === "" ? "inherit" : props.color};
  transition: background-color 500ms;
`;

export const ChangeBgBtn = styled.div`
  display: inline-block;
  width: 32px;
  height: 32px;
  background: url(${changebg}) no-repeat center;
  cursor: pointer;
  position: relative;
  vertical-align: middle;
`;

export const UserColorChoose = styled.div`
  position: relative;
  display: inline-block;
  width: 32px;
  height: 32px;
  vertical-align: middle;
  cursor: pointer;
  margin-right: 16px;
  margin-top: 30px;
`;

export const UserColorChooseBlock = styled.div`
  position: absolute;
  left: -70px;
  bottom: 40px;
  box-shadow: 0 1px 16px 0 rgba(34, 60, 80, 0.2);

  @media (max-width: 940px) {
    left: 0;
  }
`;

export const AddButton = styled(IconWrapperAdd)`
  cursor: pointer;

  &:not(:first-child) {
    margin-left: 16px;
  }
`

export const AlignedTagsGrid = styled(BTagsGrid)`
  align-items: center;
  width: 100%;
  max-width: none;
  max-height: 85px;
  overflow-y: auto;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    max-height: 75px;
  }
`

export const CompetitionHead = styled.h6<IBgLayout>`
  font-weight: 600;
  font-size: 42px;
  line-height: 48px;
  user-select: none;
  color: ${(props) =>
    props.color === "" ? "inherit" : props.color};
`;

export const CompetitionJuryCardsWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
`;
export const CompetitionJuryCardWrapper = styled.div`
    display: flex;
    flex-flow: column;
    width: clamp(145px, 100%, 270px);
`;

export const CompetitionJuryCardImgContainer = styled(FlexBox)<any>`
    width: 100%;
    aspect-ratio: 1 / 1;
    margin-bottom: 17px;
    cursor: pointer;

    & > div {
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cover;
      width: 100%;
      height: 100%;
    }
      
    media (max-width: ${LayoutConst.screen.l}px){
      margin-bottom: 12px;
    }
`;

export const CompetitionJuryCardImg = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    user-select: none;

`;

export const CompetitionJuryCardLink = styled(ExternalLink)`
  display: flex;
  flex-direction: column;
`;

export const CompetitionJuryCardText = styled.p<IFsProp>`
    font-size: ${(props) =>
      props.isShowcase ? 15 : props.fontSize === "" ? "24px" : props.isMobile ? "1rem" : props.fontSize + "px"};
    color: ${(props) =>
      props.color === "" ? + "inherit" : props.color};
    font-weight ${props => props.fw ? `${props.fw}` : "inherit"};
    line-height: ${props => props.lh ? `${props.lh}px` : "inherit"};
    margin: 0;
    padding-top: ${props => props.pt ? `${props.pt}px` : "0"};
    user-select: none;
    cursor: pointer;
    width: ${props => !props.isMobile && props.halfBlock ? `${props.halfBlock}px` : "auto"};
    letter-spacing: ${props => props.ls ? `${props.ls}em` : "normal"};
    font-family: 'Inter';
`;

export const CompetitionJuryDescriptionWrapper = styled.div<{ isShowcase?: boolean }>`
  padding-top: 8px;

  ${ShowMoreContent} {
    line-height: ${({ isShowcase }) => isShowcase ? '20px' : '0.95'};
  }

  .__react_component_tooltip {
    ::before {
      display: none;
    }
    opacity: 1 !important;
    border-radius: 6px;
    padding: 2px 8px 4px !important;
    height: auto;
    font-size: 11px;
    line-height: 13px;
  }

  span {
    color: #909090;
    font-size: ${({ isShowcase }) => isShowcase ? '15px' : '13px'};
  }
  p {
    padding-top: 0px;
  }

  a {
    color: ${({ isShowcase }) => isShowcase ? Colors.galBlack27 : Colors.galBlack73};
    font-size: ${({ isShowcase}) => isShowcase ? '15px' : '13px'};
    line-height: ${({ isShowcase}) => isShowcase ? '20px' : '16px'};
    margin-right: 0;
    @media(max-width: ${LayoutConst.screen.m}px) {
        font-size: 11px;
    }
    &:hover {
      color: ${Colors.galBlack31};
    }
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    margin-bottom: 16px;
    padding-top: 0;
    p {
      padding-top: 2px;
    }

    ${ShowMoreContent} {
      line-height: 1.02;
    }
    span {
      font-size: 11px;
    }
  }
`;

export const SortableWrapper = styled(ProjectEditPageGridList)`

tbody, tr {
  width: 100%;
}
  tr {
    padding-bottom: 16px;
  }

  td {
    height: 48px;
    max-height: 48px;
    min-height: 48px;
    padding-bottom: 16px;
  }

  input {
    width: 100% !important;
    background-color: ${({theme}) => theme.competition.input.bg} !important;
    color: ${({theme}) => theme.competition.input.inputText} !important;
  }

  ${DefaultButton} {
    background-color: transparent !important;
    color: ${({theme}) => theme.competition.input.inputText} !important;
    border-color: ${({theme}) => theme.competition.input.bg};
    font-size: 17px;
    line-height: 22px;
    height: 38px;
  }
`;


export const Counter = styled.div`
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  color: rgba(144, 144, 144, 1);
  font-size: 10px;
  line-height: 13px;
`;

export const CriteriaWrapper = styled(FlexBox)`

.brg-input__control {
  height: 40px !important;
}
.icon {
  cursor: pointer;

  &:hover {
    path {
      fill: #151514;
    }
  }

}

${DefaultButton} {
    background-color: transparent !important;
    color: ${({theme}) => theme.competition.input.inputText} !important;
    border-color: ${({theme}) => theme.competition.input.bg};
    font-size: 17px;
    line-height: 22px;
    height: 38px;
    svg path {
      fill: ${({theme}) => theme.competition.input.inputText} !important;
    }
}
.brg-input__single-value {
  color: ${({theme}) => theme.competition.input.inputText} !important;
}

.brg-input__control, .brg-input__menu {
  background-color: ${({theme}) => theme.competition.input.bg} !important;
  color: ${({theme}) => theme.competition.input.inputText} !important;
  border: none;
}

.brg-input__menu-list {
  color: ${({theme}) => theme.competition.input.inputText} !important;
  ::-webkit-scrollbar {
      height: 2px;
  }
  ::-webkit-scrollbar-thumb {
  background: ${({ theme }) => theme.tagAdminPage.scrollBar.bg};
  }
  ::-webkit-scrollbar-track {
  background: ${({ theme }) => theme.tagAdminPage.scrollBar.trackBg};
  }
}

.brg-input__indicator {
  opacity: 1;
  svg path {
      fill: ${({ theme }) => theme.tagAdminPage.icons.fill};
  }
}

.brg-input__menu {
  * {
    color: ${({theme}) => theme.competition.input.inputText} !important;
      font-weight: 600;
      font-size: 13px;
      line-height: 16px;
  }

  svg path {
      fill: ${({ theme }) => theme.tagAdminPage.select.color};
  }
}
`;




import styled, { createGlobalStyle, css } from "styled-components";
import { Colors, FInter, FlexBox, ExternalLink } from "@brg/ui";
import changebg from "./changebg.svg";
import { bColor } from "../../../core/utils/bColor";
import { LabelRedStar } from "../../../shared/pages/designerEditView/styles";
import { IconWrapperAdd } from "../../../shared/assets/styles";
import { BTagsGrid } from "../../../core/components";
import { LayoutConst } from "core/modules";
import { ShowMoreContent } from "shared/pages/designer/styles";
import { ProjectEditPageGridList } from "_deziiign/books/pages/BookEdit/styles";
import { DefaultButton } from "shared/pages/teams/styles";

export const ProjectEditPageContainer = styled(FlexBox)`
  flex-direction: column;
  width: 100%;
  padding-top: 40px;

  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

  .brg-input__value-container {
    height: 34px;
  }

  .tagss {
    .brg-input__control {
      width: 432px;
      overflow-x: scroll;
      overflow-y: hidden;
      padding-top: 3px;

      &::-webkit-scrollbar {
        display: none;
      }
    }

    .brg-input__value-container {
      width: auto !important;
      min-width: 10000px;
      max-width: 10000px;
      height: 40px;
      overflow: hidden;
    }
  }

  .brg-input__control {
    .gixVUY {
      top: -1px;
    }
  }

  .brg-input__option {
    position: relative;
  }

  .brg-input__menu-list {
    //min-height: 280px;
  }

  .brg-input__menu {
    z-index: 2000;
  }

  //@fixme: Z-position error
  .brg-input__menu {
    z-index: 100 !important;
  }

  .head__grey {
    margin-top: 0;
    padding-top: 0;
  }

  .brg-input__value-container {
    overflow: hidden;
    max-height: 40px;
  }

  @media (max-width: 940px) {
    margin-top: 24px;
  }
`;

export const ProjectEditPageGrid = styled(FlexBox)`
  flex-direction: column;
  width: 100%;
`;

export const ProjectEditPageGridRow = styled(FlexBox)`
  &:not(:first-child) {
    margin-top: 32px;
  }
`;

export const ProjectEditPageGridAuthorRow = styled(FlexBox)`
  &:not(:first-child) {
    margin-top: 8px;
  }
`;

export const ProjectEditPageGridLabel = styled(FInter.SmallTextFlex)`
  font-size: 18px;
  line-height: 32px;
  color: ${({ theme }) => theme.projectEdit.label};
  width: 127px;
  min-width: 127px;
  align-items: center;
  margin-right: 24px;
`;

// выбор бг на дезигне

interface IBgLayout {
  color: string;
  brighter?: string;
  darker?: string;
}

interface IFsProp {
  isMobile?: boolean;
  fontSize?: string;
  color?: string;
  pt?: string;
  fw?: string;
  lh?: string;
  ls?: string;
  halfBlock?: string;
  isShowcase?: boolean;
}

export const GlobalColoring = createGlobalStyle<IBgLayout>`
  ${(props) =>
    props.color && props.color !== ""
      ? css`
          .custom_title {
            color: ${bColor.isDark(props.color)
              ? Colors.geoWhite100
              : Colors.galBlack100};
          }
          ${LabelRedStar} {
            color: ${bColor.isDark(props.color) ? "#ff0000" : Colors.redFailed};
          }
          // .brg-input__option--is-focused {
          //     background: ${props.darker} !important;
          // }
          // .brg-input__control--is-focused {
          // }
          // .brg-input__menu,
          // .select__control,
          // .brg-input__control {
          //     background-color: ${props.brighter} !important;
          //     background: ${props.brighter} !important;
          //     border-color: ${props.darker} !important;
          //     border: 1px solid ${props.darker} !important;
          // }
        `
      : null};
`;

export const BgLayout = styled.div<IBgLayout>`
  background-color: ${(props) =>
    props.color === "" ? "inherit" : props.color};
  transition: background-color 500ms;
`;

export const ChangeBgBtn = styled.div`
  display: inline-block;
  width: 32px;
  height: 32px;
  background: url(${changebg}) no-repeat center;
  cursor: pointer;
  position: relative;
  vertical-align: middle;
`;

export const UserColorChoose = styled.div`
  position: relative;
  display: inline-block;
  width: 32px;
  height: 32px;
  vertical-align: middle;
  cursor: pointer;
  margin-right: 16px;
  margin-top: 30px;
`;

export const UserColorChooseBlock = styled.div`
  position: absolute;
  left: -70px;
  bottom: 40px;
  box-shadow: 0 1px 16px 0 rgba(34, 60, 80, 0.2);

  @media (max-width: 940px) {
    left: 0;
  }
`;

export const AddButton = styled(IconWrapperAdd)`
  cursor: pointer;

  &:not(:first-child) {
    margin-left: 16px;
  }
`

export const AlignedTagsGrid = styled(BTagsGrid)`
  align-items: center;
  width: 100%;
  max-width: none;
  max-height: 85px;
  overflow-y: auto;

  @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
    max-height: 75px;
  }
`

export const CompetitionHead = styled.h6<IBgLayout>`
  font-weight: 600;
  font-size: 42px;
  line-height: 48px;
  user-select: none;
  color: ${(props) =>
    props.color === "" ? "inherit" : props.color};
`;

export const CompetitionJuryCardsWrapper = styled.div`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
`;
export const CompetitionJuryCardWrapper = styled.div`
    display: flex;
    flex-flow: column;
    width: clamp(145px, 100%, 270px);
`;

export const CompetitionJuryCardImgContainer = styled(FlexBox)<any>`
    width: 100%;
    aspect-ratio: 1 / 1;
    margin-bottom: 17px;
    cursor: pointer;

    & > div {
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cover;
      width: 100%;
      height: 100%;
    }
      
    media (max-width: ${LayoutConst.screen.l}px){
      margin-bottom: 12px;
    }
`;

export const CompetitionJuryCardImg = styled.img`
    width: 100%;
    height: 100%;
    object-fit: cover;
    user-select: none;

`;

export const CompetitionJuryCardLink = styled(ExternalLink)`
  display: flex;
  flex-direction: column;
`;

export const CompetitionJuryCardText = styled.p<IFsProp>`
    font-size: ${(props) =>
      props.isShowcase ? 15 : props.fontSize === "" ? "24px" : props.isMobile ? "1rem" : props.fontSize + "px"};
    color: ${(props) =>
      props.color === "" ? + "inherit" : props.color};
    font-weight ${props => props.fw ? `${props.fw}` : "inherit"};
    line-height: ${props => props.lh ? `${props.lh}px` : "inherit"};
    margin: 0;
    padding-top: ${props => props.pt ? `${props.pt}px` : "0"};
    user-select: none;
    cursor: pointer;
    width: ${props => !props.isMobile && props.halfBlock ? `${props.halfBlock}px` : "auto"};
    letter-spacing: ${props => props.ls ? `${props.ls}em` : "normal"};
    font-family: 'Inter';
`;

export const CompetitionJuryDescriptionWrapper = styled.div<{ isShowcase?: boolean }>`
  padding-top: 8px;

  ${ShowMoreContent} {
    line-height: ${({ isShowcase }) => isShowcase ? '20px' : '0.95'};
  }

  .__react_component_tooltip {
    ::before {
      display: none;
    }
    opacity: 1 !important;
    border-radius: 6px;
    padding: 2px 8px 4px !important;
    height: auto;
    font-size: 11px;
    line-height: 13px;
  }

  span {
    color: #909090;
    font-size: ${({ isShowcase }) => isShowcase ? '15px' : '13px'};
  }
  p {
    padding-top: 0px;
  }

  a {
    color: ${({ isShowcase }) => isShowcase ? Colors.galBlack27 : Colors.galBlack73};
    font-size: ${({ isShowcase}) => isShowcase ? '15px' : '13px'};
    line-height: ${({ isShowcase}) => isShowcase ? '20px' : '16px'};
    margin-right: 0;
    @media(max-width: ${LayoutConst.screen.m}px) {
        font-size: 11px;
    }
    &:hover {
      color: ${Colors.galBlack31};
    }
  }

  @media(max-width: ${LayoutConst.screen.md}px) {
    margin-bottom: 16px;
    padding-top: 0;
    p {
      padding-top: 2px;
    }

    ${ShowMoreContent} {
      line-height: 1.02;
    }
    span {
      font-size: 11px;
    }
  }
`;

export const SortableWrapper = styled(ProjectEditPageGridList)`

tbody, tr {
  width: 100%;
}
  tr {
    padding-bottom: 16px;
  }

  td {
    height: 48px;
    max-height: 48px;
    min-height: 48px;
    padding-bottom: 16px;
  }

  input {
    width: 100% !important;
    background-color: ${({theme}) => theme.competition.input.bg} !important;
    color: ${({theme}) => theme.competition.input.inputText} !important;
  }

  ${DefaultButton} {
    background-color: transparent !important;
    color: ${({theme}) => theme.competition.input.inputText} !important;
    border-color: ${({theme}) => theme.competition.input.bg};
    font-size: 17px;
    line-height: 22px;
    height: 38px;
  }
`;


export const Counter = styled.div`
  position: absolute;
  top: 50%;
  right: 10px;
  transform: translateY(-50%);
  color: rgba(144, 144, 144, 1);
  font-size: 10px;
  line-height: 13px;
`;

export const CriteriaWrapper = styled(FlexBox)`

.brg-input__control {
  height: 40px !important;
}
.icon {
  cursor: pointer;

  &:hover {
    path {
      fill: #151514;
    }
  }

}

${DefaultButton} {
    background-color: transparent !important;
    color: ${({theme}) => theme.competition.input.inputText} !important;
    border-color: ${({theme}) => theme.competition.input.bg};
    font-size: 17px;
    line-height: 22px;
    height: 38px;
    svg path {
      fill: ${({theme}) => theme.competition.input.inputText} !important;
    }
}
.brg-input__single-value {
  color: ${({theme}) => theme.competition.input.inputText} !important;
}

.brg-input__control, .brg-input__menu {
  background-color: ${({theme}) => theme.competition.input.bg} !important;
  color: ${({theme}) => theme.competition.input.inputText} !important;
  border: none;
}

.brg-input__menu-list {
  color: ${({theme}) => theme.competition.input.inputText} !important;
  ::-webkit-scrollbar {
      height: 2px;
  }
  ::-webkit-scrollbar-thumb {
  background: ${({ theme }) => theme.tagAdminPage.scrollBar.bg};
  }
  ::-webkit-scrollbar-track {
  background: ${({ theme }) => theme.tagAdminPage.scrollBar.trackBg};
  }
}

.brg-input__indicator {
  opacity: 1;
  svg path {
      fill: ${({ theme }) => theme.tagAdminPage.icons.fill};
  }
}

.brg-input__menu {
  * {
    color: ${({theme}) => theme.competition.input.inputText} !important;
      font-weight: 600;
      font-size: 13px;
      line-height: 16px;
  }

  svg path {
      fill: ${({ theme }) => theme.tagAdminPage.select.color};
  }
}
`;




